$(document).ready(function () {
// Why We're different mobile slider
    // current slide pagination 
    var pagination = $('.js-why-we-different-pagination');
    var slider = $('.js-why-we-different-slider');

    slider.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        if (!slick.$dots) {
            return;
        }

        var i = (currentSlide ? currentSlide : 0) + 1;
        pagination.text(i + '/' + (slick.$dots[0].children.length));
    });

    slider.slick({
        infinite: true,
        speed: 300,
        arrows: true,
        dots: true,
        prevArrow: '<div class="prev-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-left-green.svg" alt="prev arrow"></div>',
        nextArrow: '<div class="next-arrow"><img src="' + ajax_object.theme_url + '/static/images/carousel-arrow-right-green.svg" alt="next arrow"></div>',
        mobileFirst: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });

});